import { render, staticRenderFns } from "./edittable.vue?vue&type=template&id=fcfae2e2&scoped=true"
import script from "./edittable.vue?vue&type=script&lang=js"
export * from "./edittable.vue?vue&type=script&lang=js"
import style0 from "./edittable.vue?vue&type=style&index=0&id=fcfae2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfae2e2",
  null
  
)

export default component.exports